let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("aC2ty")).then(() => parcelRequire('donzV'));